import { render, staticRenderFns } from "./GameBackground.vue?vue&type=template&id=23bf74e8&scoped=true&"
import script from "./GameBackground.vue?vue&type=script&lang=ts&"
export * from "./GameBackground.vue?vue&type=script&lang=ts&"
import style0 from "./GameBackground.vue?vue&type=style&index=0&id=23bf74e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf74e8",
  null
  
)

export default component.exports